import { useCreation } from 'ahooks';
import { SvgIcon, type SvgIconProps } from '@mui/material';

type MySvgIconProps = {
  name: string;
  color?: string;
  width: number | string;
  height: number | string;
};

export const MySvgIcon: React.FC<MySvgIconProps & SvgIconProps> = (props) => {
  const { name, color, width, height, ...restProps } = props;

  const defaultState = useCreation(() => {
    return {
      symbolId: `#icon-${name}`,
      color: color || 'currentColor',
    };
  }, [name, color]);

  return (
    <SvgIcon
      {...restProps}
      sx={{
        width: {
          xl: width + 'px',
          lg: width + 'px',
          md: +width * 0.875 + 'px',
          sm: +width * 0.75 + 'px',
          xs: +width * 0.75 + 'px',
        },
        height: {
          xl: height + 'px',
          lg: height + 'px',
          md: +height * 0.875 + 'px',
          sm: +height * 0.75 + 'px',
          xs: +height * 0.75 + 'px',
        },
      }}
    >
      <svg aria-hidden="true" className="svg-icon" viewBox={`0 0 ${width} ${height}`} name={name}>
        <use href={defaultState.symbolId} fill={defaultState.color} />
      </svg>
    </SvgIcon>
  );
};
